import * as apiPublic from "@api/public";
import DetailsGrid from '@components/detailsGrid';
import React, { useState, useCallback, useEffect } from "react";
import { useNavigator } from "@contexts/NavigatorContext";
import styles from "./Utente.module.css";
import AnnuncioPreview from '@templates/annunci/AnnuncioPreview';
import { checkConstant, VALIDATION_STATUS } from "@logic/constants";
import Icon from "@components/icon";
import { useSelector } from "react-redux";
import { selectUser } from '@store/userSlice';

const Utente = () => {
  const { currentRoute } = useNavigator();
  
  const user = useSelector(selectUser);

  const [utente, setUtente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [advertisements, setAdvertisements] = useState([]);

  const loadUtente = useCallback(async () => {
    setLoading(true);
    apiPublic.GetUser({ userId: currentRoute.params[0] })
      .then((data) => setUtente(data))
      .catch(() => setUtente(null))
      .finally(() => setLoading(false));
  }, [currentRoute]);

  const loadUserAdvertisements = useCallback(async () => {
    setLoading(true);
    apiPublic.GetUserAdvertisements({ userId: currentRoute.params[0] })
      .then((data) => setAdvertisements(data))
      .catch(() => setAdvertisements([]))
      .finally(() => setLoading(false));
  }, [currentRoute]);

  useEffect(() => {
    loadUtente();
    loadUserAdvertisements();
  }, [loadUtente, loadUserAdvertisements]);

  const annunciList = useCallback(() => (
    advertisements.map((x) => {
      let icon = "event_available";
      let className = styles.success;
      let text = "Attivo";

      if (x.isSuspended) {
        icon = "pause_circle";
        className = styles.error;
        text = "Sospeso";
      } else if (x.isExpired) {
        icon = "event_busy";
        className = styles.error;
        text = "Scaduto";
      } else if (checkConstant(VALIDATION_STATUS.WAITING, x.validationStatus)) {
        icon = "hourglass_empty";
        className = "";
        text = "In attesa di verifica";
      } else if (checkConstant(VALIDATION_STATUS.REFUSED, x.validationStatus)) {
        icon = "block";
        className = styles.error;
        text = "Rifiutato";
      }

      return (
        <AnnuncioPreview
          key={x.id}
          annuncio={x}
          onClick={()=>alert("")}
          disabled={loading}
        >

        {user.isAdmin && (
          <>
          <div className={styles.actions}>
            <span className={styles.status + " " + className}>
              <Icon
                name={icon}
                size={18}
                fill={1}
                weight={400}
                grade={-25}
                opticalSize={20}
              />
              {text}
            </span>
          </div>
          </>
        )}
        </AnnuncioPreview>
      );
    })
  ), [advertisements, loading, user.isAdmin /*navigate*/]); //, ripubblica, sospendi, onEliminaClick]);

  if (!utente) {
    return null;
  }

  return (
    <>
      <br></br>
      <div className='row'>
        <div className='col'>
          <span className='page-title'>Profilo utente di {utente.advertisementName}</span>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <DetailsGrid
            labels={["Username", "Cellulare", "Telefono"]}
            values={[utente.advertisementName, utente.cel, utente.tel]}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <div className={styles.wrapperAnnunci}>
            {annunciList()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Utente;

